import WishList from 'Vue/components/WishList/WishList.vue';
import store from "Store/index";
import { createApp } from "vue";

let module:any = {};

/**
 * Instantiate Vue Application
 */
module.wishListVueApp = function () {
	const sv = createApp(WishList).use(store);
	sv.mount("#wishList");
};

module.init = function () {
	module.wishListVueApp();
};

document.addEventListener("DOMContentLoaded", () => {
	module.init();
});
